import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Alert } from 'reactstrap'

import { PageLoader } from '../../generic'
import { TERMS } from '../constants'
import { register as registerUser } from '../store/actions'
import { getSubmitting } from '../store/selectors'

import Input from './generic/Input'
import SubmitButton from './generic/SubmiButton'
import useErrors from './generic/useErrors'

const AcceptTermsText = () => (
  <>
    Ich bin mit den
    {' '}
    <a
      target='_blank'
      rel='noreferrer'
      href={TERMS.termsOfUse.href}
      title={TERMS.termsOfUse.title}
    >
      {TERMS.termsOfUse.title}
    </a>
    {' '}
    und den
    {' '}
    <a
      target='_blank'
      rel='noreferrer'
      href={TERMS.privacyPolicy.href}
      title={TERMS.privacyPolicy.title}
    >
      {TERMS.privacyPolicy.title}
    </a>
    {' '}
    der Yourfirm GmbH & Co. KG einverstanden.
  </>
)

const inputFields = [
  {
    type: 'email',
    className: 'form-control qa-email',
    placeholder: 'E-Mail',
    name: 'email',
    required: true
  },
  {
    type: 'password',
    className: 'form-control qa-password1',
    placeholder: 'Passwort',
    name: 'password1',
    required: true
  },
  {
    type: 'password',
    className: 'form-control qa-password2',
    placeholder: 'Passwort wiederholen',
    name: 'password2',
    required: true
  }
]

const inputCheckboxes = [
  {
    type: 'checkbox',
    className: 'custom-control-input',
    name: 'newsletter',
    label: 'Karriere-Newsletter kostenfrei erhalten',
    required: false
  },
  {
    type: 'checkbox',
    className: 'custom-control-input qa-terms',
    name: 'accept_terms',
    label: <AcceptTermsText />,
    required: true
  }
]

const RegistrationForm = () => {
  const dispatch = useDispatch()
  const methods = useForm()
  const { handleSubmit, setError, setFocus } = methods
  const isSubmitting = useSelector(getSubmitting)
  const { formSubmitMessages, resetErrors } = useErrors(setError)

  const onSubmit = data => {
    resetErrors()
    dispatch(registerUser(data))
  }

  useEffect(() => {
    setFocus('email')
  }, [setFocus])

  return (
    <FormProvider {...methods}>
      <form
        className='form form-register qa-form-register'
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        {formSubmitMessages.length > 0 &&
          <div>
            <Alert color='danger'>{formSubmitMessages.toString()}</Alert>
          </div>}

        {inputFields.map((
          { type, className, placeholder, message, name, required },
          idx) => (
            <div key={idx} className='form-group'>
              <Input
                type={type}
                className={className}
                placeholder={placeholder}
                message={message}
                name={name}
                required={required}
              />
            </div>
        ))}

        {inputCheckboxes.map((
          { type, className, name, label, required },
          idx) => (
            <div key={idx} className='form-group'>
              <div className='custom-control custom-checkbox'>
                <Input
                  type={type}
                  className={className}
                  name={name}
                  required={required}
                />
                <label className='custom-control-label' htmlFor={name}>
                  {label}
                </label>
              </div>
            </div>
        ))}
        <div className='d-flex flex-column flex-lg-row justify-content-around w-100 mb-lg-2'>
          {isSubmitting
            ? <PageLoader />
            : <SubmitButton classname='btn btn-primary qa-submit' text='Absenden' />}
        </div>
      </form>
    </FormProvider>
  )
}

RegistrationForm.propTypes = {
  requestErrors: PropTypes.shape({
    $messages: PropTypes.arrayOf(PropTypes.string)
  })
}

export default RegistrationForm
